import React from 'react';
import s from './styles.module.css';
import Media from 'react-media';

function renderCard({shouldTranslate, noMargin, square, minHeight, height, width, children}) {
  let containerClassName = s.container;
  if (noMargin) {
    containerClassName += ` ${s.noMargin}`
  }
  if (square) {
    containerClassName += ` ${s.square}`
  }
  return (
    <div className={shouldTranslate ? s.wrapper : `${s.wrapper} ${s.noTranslate}`}>
      <div className={containerClassName} style={{ minHeight, height, width }}>
        {children}
      </div>
    </div>
  );
}

export default function(props) {
  const children = props.children;
  const shouldTranslate = typeof props.translate === 'boolean' ? props.translate : true;
  const noMargin = typeof props.noMargin === 'boolean' ? props.noMargin : false;
  const square = typeof props.square === 'boolean' ? props.square : false;
  const mobileLayout = typeof props.mobileLayout === 'boolean' ? props.mobileLayout : false;
  const minHeight = typeof props.minHeight === 'number' ? props.minHeight : 300;
  const height = typeof props.height === 'number' ? props.height : 'auto';
  const width = typeof props.width === 'number' ? props.width : 'auto';

  if (mobileLayout) {
    return (
      <Media query="(max-width: 480px)">
        {matches =>
          matches ? (
            renderCard({shouldTranslate: false, noMargin: true, square: true, minHeight, height, width, children})
          ) : (
            renderCard({shouldTranslate, noMargin, square, minHeight, height, width, children})
          )
        }
      </Media>
    );
  }

  return renderCard({shouldTranslate, noMargin, square, minHeight, height, width, children});
};
